import React from "react";
import { useQuery } from "react-query";
import { EuiBasicTable, EuiCallOut } from "@elastic/eui";
import { getReleaseActivity } from "../../api/appReleases";
import {
  formatDateTime,
  getErrorMessage,
  RELEASE_QUERY_KEY,
  REFRESH_INTERVAL_MS,
} from "./helpers";

const columns = [
  {
    field: "actor",
    name: "Who",
    render: (actor) => (actor && actor.name ? actor.name : actor || "-"),
  },
  { field: "action", name: "What" },
  {
    field: "reason",
    name: "Reason",
    render: (reason) => reason || "-",
  },
  {
    field: "created_at",
    name: "When",
    render: formatDateTime,
  },
];

const ActivityTab = ({ releaseId }) => {
  const { data, isLoading, error } = useQuery(
    [RELEASE_QUERY_KEY, "activity", releaseId],
    () => getReleaseActivity(releaseId),
    { refetchInterval: REFRESH_INTERVAL_MS, retry: false },
  );

  if (error) {
    return (
      <EuiCallOut
        size="s"
        color="danger"
        iconType="alert"
        title={getErrorMessage(error)}
      />
    );
  }

  return (
    <EuiBasicTable
      items={data || []}
      columns={columns}
      loading={isLoading}
      noItemsMessage="No activity yet"
    />
  );
};

export default ActivityTab;
